export default [
  {
    path: 'Pilotage',
    name: '领航版',
    meta: { title: '领航版' },
    component: () =>
      import(/* webpackChunkName: "PilotageRecomment" */ '@/views/Solve/Pilotage'),
  },
  {
    path: 'cruise',
    name: '巡航版',
    meta: {
      title: '巡航版',
    },
    component: () =>
      import(/* webpackChunkName: "cruiseRecomment" */ '@/views/Solve/cruise'),
  },
  {
    path: 'Setsail',
    meta: {
      title: '启航版',
    },
    name: '启航版',
    component: () =>
      import(/* webpackChunkName: "SetsailRecomment" */ '@/views/Solve/Setsail'),
  },
];
